module.exports = __webpack_public_path__ + "static/media/open.511c06d9.svg";